<template>
  <template v-if="isFileError">
    <span class="signing-checklist-document-warning text--x-small" v-bind="$attrs">
      <span v-if="textInline" class='mx-1'>-</span>
      <app-material-icon
        name="warning"
        filled
        size="xs"
        color="icon-warning"
        class="mr-1 pb-1"
      />
      <span>{{ errorMessage }}</span>
    </span>
  </template>
</template>

<script setup lang="ts">
import { computed, PropType, watchEffect } from 'vue'

import { useTranslation } from '@/common/utils/translation'
import { SIGNATURE_DOCUMENT_ERROR } from '@/project/signing-checklist/constants'
import { SigningChecklistFile } from '@/project/views/SigningChecklistAdd.vue'

const { t } = useTranslation({ keyPrefix: 'project.signing-checklist.SigningChecklistDocumentWarning' })

const props = defineProps({
  file: {
    type: Object as PropType<SigningChecklistFile>,
    required: false,
    default: () => ({}),
  },
  textInline: {
    type: Boolean,
    default: false,
  },
})

const maxSignablePages = Number(import.meta.env.VUE_APP_MAX_SIGNABLE_PAGES)

const isFileOverPages = computed(() => {
  const nbPages = Number(
    props.file.originalFile?.nbPages ??
    props.file.nbPages ??
    props.file.objectToPost?.envelope?.file?.nbPages,
  )
  return nbPages > maxSignablePages
})

const isFileError = computed(() => {
  return isFileOverPages.value
})

const errorMessage = computed(() => {
  if (isFileOverPages.value) {
    return t(SIGNATURE_DOCUMENT_ERROR.ERROR_OVER_PAGES, { maxSignablePages }) + t('toChangeFile')
  }
  return ''
})

const emit = defineEmits(['update:isFileOverPages'])
watchEffect(() => {
  emit('update:isFileOverPages', isFileOverPages.value)
})
</script>

<style scoped>
  .signing-checklist-document-warning {
    display: flex;
    align-items: center;
  }
</style>
